export default "__VITE_ASSET__48c5cf73__"